<template>
  <form @submit.prevent="onSubmit">
    <div class="wizard-header">
      <h3 class="wizard-title">{{ wizardTitle }}</h3>
      <p class="category">{{ wizardDescription }}</p>
    </div>

    <insurers></insurers>

    <wizard-navigation :step="step"></wizard-navigation>

    <sweet-modal
      ref="emailQuote"
      overlay-theme="dark"
      icon="success"
      :hideCloseButton="true"
    >
      <p>Congratulations! Your quote has been sent to {{ fields.email }}</p>
      <button
        type="button"
        class="btn btn-wd p-x-45-i btn-blue active"
        v-on:click="$refs.emailQuote.close()"
      >
        OK
      </button>
    </sweet-modal>

    <div class="tab-content details-tab-content">
      <div
        class="tab-pane"
        v-bind:class="{ active: step == 3 }"
        v-if="step == 3"
      >
        <error-message></error-message>

        <div v-if="cheapUnderwriter" class="row">
          <div class="col-sm-12 cheap-underwriter pb-4">
            <quote
              :selectDisabled="selectDisabled"
              :selectShow="selectShow"
              :selected="fields.underwriter_id == cheapUnderwriter.id"
              :calculating="
                calculating == cheapUnderwriter.prefix || calculating == 'all'
              "
              :underwriter="cheapUnderwriter"
              v-on:select="fields.underwriter_id = cheapUnderwriter.id"
            >
              <span slot="header">
                <img
                  :src="cheapUnderwriter.logo"
                  :alt="cheapUnderwriter.name"
                  class="underwriter-logo"
                />
              </span>
              <template slot="form">
                <label> Deductible (<em>Excess</em>) </label>
                <button-group
                  :values="
                    deductible_options[cheapUnderwriter.prefix] ||
                    deductible_options.def
                  "
                  :value="form[cheapUnderwriter.prefix].deductible"
                  :name="'deductible'"
                  :size="'default'"
                  :justified="false"
                  :disabled="selectDisabled || cheapUnderwriter.disabled"
                  v-on:change="
                    form[cheapUnderwriter.prefix].deductible = Number($event)
                  "
                />

                <label>Required Public Liability Amount</label>
                <button-group
                  :values="amount_options"
                  :value="form[cheapUnderwriter.prefix].limits_required"
                  :name="'limits_required'"
                  :size="'default'"
                  :justified="false"
                  :disabled="selectDisabled || cheapUnderwriter.disabled"
                  v-on:change="
                    form[cheapUnderwriter.prefix].limits_required = Number(
                      $event
                    )
                  "
                />

                <label>Period of Cover Required</label>
                <select
                  class="form-control"
                  v-model="form[cheapUnderwriter.prefix].period_of_cover"
                  :disabled="
                    selectDisabled ||
                    cheapUnderwriter.disabled ||
                    cheapUnderwriter.prefix == 'brooklyn' ||
                    cheapUnderwriter.prefix == 'ensurance'
                  "
                >
                  <option value="" disabled selected>
                    - Please choose period of cover -
                  </option>
                  <option
                    v-for="month in configs.period_of_cover_by_months"
                    :key="month"
                    :value="month"
                  >
                    {{ month }} Months
                  </option>
                </select>
              </template>
            </quote>
          </div>
        </div>

        <div class="row justify-content-center" v-if="otherUnderwriters.length">
          <div class="col-sm-12 text-center">
            <a href="#" @click.prevent="handleToggleOtherQuotes">
              <span v-if="!showOtherUnderwriters"> Show all the quotes </span>
              <span v-else> Hide all the quotes </span>
            </a>
          </div>
        </div>

        <div
          class="row justify-content-center pb-4"
          v-show="showOtherUnderwriters"
        >
          <div
            class="underwriters col-sm-10 col-sm-offset-1 d-flex justify-content-center"
          >
            <quote
              v-for="underwriter in otherUnderwriters"
              :key="underwriter.id"
              :selectDisabled="selectDisabled"
              :selectShow="selectShow"
              :selected="fields.underwriter_id == underwriter.id"
              :calculating="
                calculating == underwriter.prefix || calculating == 'all'
              "
              :underwriter="underwriter"
              v-on:select="fields.underwriter_id = underwriter.id"
            >
              <span slot="header">
                <img
                  :src="underwriter.logo"
                  :alt="underwriter.name"
                  class="underwriter-logo"
                />
              </span>
              <template slot="form">
                <label> Deductible (<em>Excess</em>) </label>
                <button-group
                  :values="
                    deductible_options[underwriter.prefix] ||
                    deductible_options.def
                  "
                  :value="form[underwriter.prefix].deductible"
                  :name="'deductible'"
                  :size="'default'"
                  :justified="false"
                  :disabled="selectDisabled || underwriter.disabled"
                  v-on:change="
                    form[underwriter.prefix].deductible = Number($event)
                  "
                />

                <label>Required Public Liability Amount</label>
                <button-group
                  :values="amount_options"
                  :value="form[underwriter.prefix].limits_required"
                  :name="'limits_required'"
                  :size="'default'"
                  :justified="false"
                  :disabled="selectDisabled || underwriter.disabled"
                  v-on:change="
                    form[underwriter.prefix].limits_required = Number($event)
                  "
                />

                <label>Period of Cover Required</label>
                <select
                  class="form-control"
                  v-model="form[underwriter.prefix].period_of_cover"
                  :disabled="
                    selectDisabled ||
                    underwriter.disabled ||
                    underwriter.prefix == 'brooklyn' ||
                    underwriter.prefix == 'ensurance'
                  "
                >
                  <option value="" disabled selected>
                    - Please choose period of cover -
                  </option>
                  <option
                    v-for="month in configs.period_of_cover_by_months"
                    :key="month"
                    :value="month"
                  >
                    {{ month }} Months
                  </option>
                </select>
              </template>
            </quote>
          </div>
        </div>

        <!-- <accident-cover-dropdown
          :disabled="selectDisabled"
          v-on:changeName="insuredIndividual = $event"
          v-on:change="handleChangeAccidentCover"
        /> -->
      </div>
    </div>

    <div class="wizard-footer" style="padding-top: 20px">
      <div class="clearfix"></div>
      <div class="pull-right">
        <button
          type="button"
          class="btn btn-next btn-fill btn-info btn-wd"
          @click="
            fields.email_quote_btn_clicked = true;
            submitForm();
          "
          :disabled="emailQuoteDisabled"
        >
          <!-- <i v-if="emailQuoteDisabled" class="fa fa-spinner fa-spin"></i> -->
          <i class="fa fa-envelope"></i>
          Email Quote
        </button>
        <button
          type="button"
          class="btn btn-next btn-fill btn-success btn-wd"
          @click="
            fields.email_quote_btn_clicked = false;
            submitForm();
          "
          :disabled="nextDisabled"
        >
          Next <i class="fa fa-arrow-right"></i>
        </button>
      </div>
      <div class="pull-left">
        <button
          class="btn btn-previous btn-default btn-wd"
          type="button"
          @click="previousClicked"
        >
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
      <div class="clearfix"></div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { SweetModal } from "sweet-modal-vue";
import * as appConfigs from "../configs";
import Cookies from "js-cookie";
import store from "../store";
import { isEmpty, omit, pick, stubTrue, clone } from "lodash";
import {
  formValidate,
  generateErrorMessage,
  requireHeatWorkPercentage,
} from "../helpers";
import axios from "axios";

import AccidentCoverDropdown from "./AccidentCoverDropdown";
import WizardNavigation from "./WizardNavigation";

export default {
  store,
  components: {
    AccidentCoverDropdown,
    SweetModal,
    WizardNavigation,
  },
  data: function () {
    return {
      fields: {
        current_annual_revenue: "",
        deductible: "",
        email_quote_btn_clicked: false,
        email: "",
        head_count: "",
        limits_required: appConfigs.defaultAmountOption,
        occupation_id: "",
        percentage_of_insured_turnover_from_by_sub_contractors: "",
        percentage_of_insured_turnover_from_premises: "",
        period_of_cover: 12,
        postcode_of_risk: "",
        referral: "",
        underwriter_id: "",
        id: null,
      },
      form: {
        protecsure: {
          limits_required: appConfigs.defaultAmountOption,
          period_of_cover: 12,
          deductible: "",
        },
        brooklyn: {
          limits_required: appConfigs.defaultAmountOption,
          period_of_cover: 12, // constant
          deductible: 1000, // constant
        },
        ensurance: {
          limits_required: appConfigs.defaultAmountOption,
          period_of_cover: 12, // constant
          deductible: 500, // constant
        },
      },
      underwriters: [],
      finishedCalculating: true,
      insuredIndividual: null,
      // isProcessing: false,
      amount_options: appConfigs.amountOptions,
      deductible_options: appConfigs.deductibleOptions,
      // state: null,
      step: 3,
      currentUnderwriter: null,
      showOtherUnderwriters: false,
    };
  },
  props: {
    wizardTitle: {
      type: String,
      required: true,
    },
    wizardDescription: {
      type: String,
      required: true,
    },
    infoText: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.dataLoad();
  },
  computed: {
    ...mapState({
      configs: (state) => state.configs,
      accidentCover: (state) => state.accidentCover,
      calculating: (state) => state.calculating,
      quoteRejected: (state) => state.quoteRejected,
      summaryData: (state) => state.summaryData,
      pendingOrder: (state) => state.pendingOrder,
    }),
    pendingOrderId() {
      return Cookies.get("pendingOrderId") || this.pendingOrder?.id;
    },

    serializedFormProtecsure: function () {
      return JSON.stringify(this.form.protecsure);
    },
    serializedFormBrooklyn: function () {
      return JSON.stringify(this.form.brooklyn);
    },
    serializedFormEnsurance: function () {
      return JSON.stringify(this.form.ensurance);
    },
    serializedFields() {
      return JSON.stringify(omit(this.fields, ["underwriter_id"]));
    },
    isValidForm() {
      const errors = formValidate(omit(this.fields, ["underwriter_id"]), {
        percentage_of_insured_turnover_from_premises: this
          .requireHeatWorkPercentage,
      });
      return isEmpty(errors);
    },
    requireHeatWorkPercentage() {
      return requireHeatWorkPercentage(
        this.fields.occupation_id,
        this.configs.occupations
      );
    },
    selectDisabled() {
      return Boolean(
        this.calculating ||
          this.quoteRejected ||
          !this.finishedCalculating ||
          !this.isValidForm
      );
    },
    nextDisabled() {
      return false;
      return (
        this.selectDisabled ||
        !this.fields.underwriter_id ||
        (this.accidentCover && !this.insuredIndividual)
      );
    },
    emailQuoteDisabled() {
      return this.selectDisabled || !this.fields.underwriter_id;
    },
    cheapUnderwriter() {
      let min = null;
      for (let i = 0; i < this.underwriters.length; i++) {
        const item = this.underwriters[i];
        if (!item.summary) {
          continue;
        }
        if (!min || item.summary.totalPrice < min.summary.totalPrice) {
          min = item;
        }
      }
      return min;
    },
    otherUnderwriters() {
      const cheap = this.cheapUnderwriter;
      if (!cheap) {
        return this.underwriters;
      }

      return this.underwriters.filter(
        (item) => item.id !== cheap.id && !item.disabled
      );
    },
    selectShow() {
      return (
        this.showOtherUnderwriters &&
        this.otherUnderwriters.some((item) => !item.disabled)
      );
    },
  },
  watch: {
    serializedFormProtecsure: function () {
      if (!this.finishedCalculating) {
        return;
      }

      this.finishedCalculating = false;
      this.calculatePrice("protecsure");
    },
    serializedFormBrooklyn: function () {
      if (!this.finishedCalculating) {
        return;
      }

      this.finishedCalculating = false;
      this.calculatePrice("brooklyn");
    },
    serializedFormEnsurance: function () {
      if (!this.finishedCalculating) {
        return;
      }

      this.finishedCalculating = false;
      this.calculatePrice("ensurance");
    },
    serializedFields: function () {
      this.finishedCalculating = false;
      this.calculatePrice(null);
    },
    underwriters(data) {
      if (
        this.fields.underwriter_id &&
        !data.some(
          (underwriter) =>
            !underwriter.disabled &&
            underwriter.id == this.fields.underwriter_id
        )
      ) {
        this.fields.underwriter_id = "";
      }
    },
    cheapUnderwriter(data) {
      if (data && !this.fields.underwriter_id) {
        this.fields.underwriter_id = data.id;
      }
    },
    showOtherUnderwriters(data) {
      // This makes the underwriter value become null when selecting show all quotes
      
      
      // if (data) {
      //   if (
      //     this.cheapUnderwriter &&
      //     this.cheapUnderwriter.id === this.fields.underwriter_id && 
      //     this.otherUnderwriters.some( (item) => !item.disabled)
      //   ) {
      //     this.fields.underwriter_id = "";
      //   }
      // }
    },
  },
  methods: {
    ...mapActions({
      scrollToTop: "scrollToTop",
      loadPendingOrder: "loadPendingOrder",
      loadUnderwriters: "loadUnderwriters",
      calculate: "calculate",
    }),

    getUnderwriters() {
      const formData = Object.keys(this.form).reduce(
        (out, item) => ({
          ...out,
          [item]: {
            ...this.fields,
            ...this.form[item],
          },
        }),
        {}
      );

      return this.loadUnderwriters(formData);
    },

    dataLoad() {
      if (!this.pendingOrder?.id) {
        return;
      }

      this.$store.commit("setScreenLoader", { showScreenLoader: true });
      this.$store.commit("setScreenLoaderText", {
        screenLoaderText:
          "Just a moment calculating your personalised quote now...",
      });

      if (this.pendingOrder.id == undefined || this.pendingOrder.id == null) {
        return;
      }
      this.loadPendingOrder({
        orderId: this.pendingOrder.id,
        fields: Object.keys(this.fields),
      })
        .then((fields) => {
          this.fields = fields;
          this.form = Object.keys(this.form).reduce((out, item) => {
            const formFields = Object.keys(
              item == "brooklyn" || item == "ensurance"
                ? omit(this.form[item], ["period_of_cover", "deductible"])
                : this.form[item]
            );
            out[item] = {
              ...this.form[item],
              ...pick(fields, formFields),
            };
            return out;
          }, {});

          return this.getUnderwriters().then((underwriters) => {
            this.underwriters = underwriters;
          });
        })
        .catch(() => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setScreenLoaderText", { screenLoaderText: " " });
        });
    },

    submitForm() {
      this.$store.commit("setScreenLoader", { showScreenLoader: true });

      const underwriter =
        this.underwriters.filter(
          (item) => item.id == this.fields.underwriter_id
        )[0] || {};
      const summaryData = underwriter.summary;

      axios
        .post(appConfigs.validateUrl, {
          ...this.fields,
          ...this.form[underwriter.prefix],
          id: this.pendingOrderId,
          step: this.step,
          accident_cover: this.accidentCover ? this.accidentCover : null,
          endorsements:
            summaryData && summaryData.endorsements
              ? summaryData.endorsements
              : [],
        })
        .then(({ data = {} } = {}) => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });

          if (data.status === "error") {
            const errorMessage = generateErrorMessage(data.errors);
            this.$store.commit("setError", { error: errorMessage });
            this.$store.commit("setSummaryData", { summaryData: false });
            // } else if (this.fields.email_quote_btn_clicked) {
            // Cookies.remove('pendingOrderId')
            // this.$store.commit('resetState')
            // window.location = window.location.href.split('?')[0]+'?message=Thank you for quoting, we will get back to you as soon as possible'
            // window.location = appConfigs.emailQuoteUrl + '?message=Thank you for quoting, we will get back to you as soon as possible'
          } else {
            this.$store.commit("setSummaryData", { summaryData });
            this.$store.commit("clearError");

            if (this.fields.email_quote_btn_clicked) {
              this.$refs.emailQuote.open();
            } else {
              this.$store.commit("incrementStep");
            }
          }

          this.scrollToTop();
        })
        .catch((error) => {
          const errorMessage = generateErrorMessage(error);
          this.$store.commit("setError", { error: errorMessage });
          this.$store.commit("setSummaryData", { summaryData: false });
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
        });
    },

    previousClicked() {
      // this.calculate();

      this.$store.commit("decrementStep");
      this.$store.commit("clearError");
      this.scrollToTop();
    },

    calculateUnderwriters(underwriters = this.underwriters, filter = stubTrue) {
      return Promise.all([
        underwriters,
        ...underwriters.filter(filter).map((underwriter) =>
          this.calculate({
            ...this.fields,
            ...this.form[underwriter.prefix],
            underwriter_id: underwriter.id,
          })
        ),
      ])
        .then(([underwriters, ...data]) => {
          const summary = data.reduce(
            (out, item) => {
              out[item.underwriterId] = item;
              return out;
            },
            this.underwriters.reduce((out, item) => {
              out[item.id] = item.summary;
              return out;
            }, {})
          );

          this.underwriters = underwriters.map((item) => ({
            ...item,
            summary: summary[item.id],
          }));
        })
        .catch((error) => {
          this.underwriters = underwriters.map((item) => {
            return filter(item)
              ? {
                  ...item,
                  summary: undefined,
                }
              : item;
          });

          return Promise.reject(error);
        });
    },

    calculatePrice: _.debounce(async function (currentUnderwriter) {
      if (!this.isValidForm) {
        return;
      }

      if (
        currentUnderwriter &&
        !isEmpty(formValidate(this.form[currentUnderwriter]))
      ) {
        return;
      }

      if (!currentUnderwriter) {
        this.$store.commit("setScreenLoader", { showScreenLoader: true });
      }

      this.$store.commit("setCalculating", {
        calculating: currentUnderwriter || "all",
      });

      await this.getUnderwriters()
        .then((underwriters) =>
          this.calculateUnderwriters(
            underwriters,
            (underwriter) =>
              !underwriter.disabled &&
              (!currentUnderwriter || underwriter.prefix === currentUnderwriter)
          )
        )
        .then(() => {
          this.$store.commit("setCalculating", { calculating: false });
          this.$store.commit("clearError");
          this.finishedCalculating = true;
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setScreenLoaderText", { screenLoaderText: " " });
        })
        .catch((error) => {
          this.$store.commit("setCalculating", { calculating: false });
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setScreenLoaderText", { screenLoaderText: " " });

          // TODO check
          if (
            error.response &&
            error.response.data &&
            error.response.data.rejectQuote
          ) {
            this.$store.commit("setQuoteRejected", { quoteRejected: true });
          }

          const errorMessage = generateErrorMessage(error);
          this.$store.commit("setError", { error: errorMessage });
        });
    }, 1000),

    handleChangeAccidentCover(accidentCover) {
      if (!accidentCover) {
        axios.delete(appConfigs.removeAccidentCovers, {
          params: { pendingOrderId: this.pendingOrderId },
        });
      }
    },

    handleToggleOtherQuotes() {
      this.showOtherUnderwriters = !this.showOtherUnderwriters;
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/form/sweetalert";

.underwriters {
  display: flex;
  flex-wrap: wrap;
}

.cheap-underwriter {
  display: flex;
  justify-content: center;
}

.sweet-modal .sweet-content-content {
  text-align: center;
}

.underwriter-logo {
  width: 90%;
  max-width: 250px;

  @media screen and (min-width: 375px) {
    width: 100%;
  }
}

.underwriter-deductible {
  color: #9a9a9a;
  line-height: 40px;
  margin-bottom: 0;
}
.btn-previous{
  border-radius: 5px !important;
}
</style>
